<template>
  <Checkbox
    :value="val"
    :title="title"
    :err-msg="errMsg"
    :color="color"
    :disabled="disabled"
    :round="round"
    :stop-propagation="stopPropagation"
    :icon="icon"
    @input="clicked"
  />
</template>

<script>
/**
 * Replaced true and false with 1 and 0
 */
import Checkbox from '@/components/checkbox.vue';

export default {
  name: 'IntCheckbox',
  components: {
    Checkbox,
  },
  props: {
    value: {
      type: null,
      required: true,
      validator: v => [0, 1].includes(Number(v || 0)),
    },
    title: {
      type: String,
      default: '',
    },
    errMsg: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'blue',
    },
    icon: {
      type: String,
      default: null,
    },
    disabled: Boolean,
    stopPropagation: Boolean,
    round: Boolean,
  },
  data() {
    return {
      val: true,
    };
  },
  watch: {
    value(val) {
      this.val = val == 1;
    },
  },
  created() {
    this.val = this.value == 1;
  },
  methods: {
    clicked(val) {
      this.val = val;
      this.$emit('input', this.val ? 1 : 0);
    },
  },
};
</script>
